import React from 'react';

import {
  Typography,
} from '@material-ui/core';


const services = () => {
  return (
    <React.Fragment>
      <Typography variant="subheading">
        {'We provide match making services for Lohana & Gujarati Vaishnav Community candidates seeking suitable life partner. We are giving opportunity to such individual candidates & their Families to Register with us Free of charge and meet suitable like minded, educated candidates with similar age group and family details.'}
        <br /><br />
        <b>Personalized Match Making Services: Every Sunday.</b> <br />
        {'These matrimonial services has been continued by Mr. Jayendra Sodha with immense joy & pleasure and same objectives to provide ultimate partner search experience and serve the community by connecting most suitable like minded Brides & Grooms and set happiness in society. Thus the seeds of this "ane  Avasar" - Jayendra Sodha Lohana/ gujarati Vaishnav community Free matrimonial information Center were planted by Late shri Ratibhai Sodha about 30 years ago.'}
        <br /><br />
        <b>Match Making Swayamvars:</b><br />
        {'We periodically organize get - to - gathers of various age group of educated /professional candidates (boys & Girls) and give them opportunity to meet, interact , understand and interview prospective other participants in search of suitable life partner.'}
        <br /><br />
        <b>Online Web Portal:</b><br />
        {'By this portal we have created a revolutionary easy to operate internet/online match making facilities with one single objective to provide ultimate partner search experience and serve the community by connecting most suitable like minded Brides & Grooms and set happiness in society.'}
        <br /><br />
        {'Ours is the largest and most trusted matrimonial services for the community with senior advisory team comprising of all business class busy persons devoting their time and efforts to assist prospective candidates in search for a true life partner. We do not charge any amount at any point of time and do not accept any compensation/gift directly or indirectly from any candidate or their family. It is just a social honorary service.'}
      </Typography>
    </React.Fragment>
  );
};


export default services;



// WEBPACK FOOTER //
// ./src/main/components/Services.js